import { SuccesHttpResponse } from '@/typings/generics';
import SimpleCrypto from 'simple-crypto-js';

export const isDevelopEnv = () => {
  if (process.env.NODE_ENV === 'development') {
    return true;
  }
  return false;
};

export const validateHttpResponse = (response: any): SuccesHttpResponse => {
  const htmlList = (obj: any) => {
    let list: string[] = [];
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        list.push(obj[key]);
      }
    }
    return list.join(', ');
  };

  if (
    response.status.toString().includes('40') ||
    response.status.toString().includes('50')
  ) {
    const message =
      response.data && response.data.message
        ? response.data.message
        : response.data.errors
        ? htmlList(response.data.errors)
        : 'Error desconocido';
    return {
      success: false,
      data:
        'Error ' + response.status + ' ' + response.statusText + ': ' + message,
    };
  }

  if (response.data) {
    return {
      success: true,
      data: response.data,
    };
  }

  return {
    success: false,
    data: 'Error desconocido',
  };
};

// Verificar que un campo e texto contenga una CURP valida
const curpRegExp =
  '[A-Z]{1}[AEIOU]{1}[A-Z]{2}' +
  '[0-9]{2}(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1])' +
  '[HM]{1}' +
  '(AS|BC|BS|CC|CS|CH|CL|CM|DF|DG|GT|GR|HG|JC|MC|MN|MS|NT|NL|OC|PL|QT|QR|SP|SL|SR|TC|TS|TL|VZ|YN|ZS|NE)' +
  '[B-DF-HJ-NP-TV-Z]{3}' +
  '[0-9A-Z]{1}' +
  '[0-9]{1}';
export const validarFormatoCURP = {
  pattern: new RegExp(curpRegExp),
  message: 'Por favor ingrese una CURP valida',
};

export const validatePhone = {
  pattern: new RegExp(
    /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im
  ),
  message: 'Porfavor ingrese un numero de telefono valido: 123-456-7890',
};

export const campoObligatorio = (Campo: string) => {
  return {
    required: true,
    message: 'El campo "' + Campo + '" es obligatorio',
  };
};

export function authHeader() {
  const token = localStorage.getItem('tokenEcosurEstudiantesExternos');
  if (token) {
    return 'Bearer ' + token;
  } else {
    return '';
  }
}

export function encrypt(text: string) {
  const key = 'EE';
  const simpleCrypto = new SimpleCrypto(key);
  const encryptText = simpleCrypto.encrypt(text);
  return encryptText.replace('/', '_');
}

export function decrypt(text: string) {
  const key = 'EE';
  const simpleCrypto = new SimpleCrypto(key);
  var decryptText;
  try {
    decryptText = simpleCrypto.decrypt(text.replace('_', '/'));
  } catch (e: any) {
    decryptText = -1;
  }
  return decryptText;
}
